/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Format_CodeInputs */

const en_format_code = /** @type {(inputs: Format_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const nl_format_code = /** @type {(inputs: Format_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatteren`)
};

/**
* | output |
* | --- |
* | "Format" |
*
* @param {Format_CodeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const format_code = /** @type {((inputs?: Format_CodeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Format_CodeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_format_code(inputs)
	return en_format_code(inputs)
});